import React, { useState, useEffect } from "react"
import { Tuple } from "components/Shared/Interfaces"
import {
	FORMATS_FILTER,
	COUNTIES,
	FORMATS,
	REGIONS,
	FORMATS_FILTER_ENDPOINT,
} from "components/Shared/GlobalFilter/constants"
import useFetchFilters from "components/Shared/GlobalFilter/hooks"
import PanelContent from "components/Shared/Filters/modules/components"
import { useFiltersContext } from "components/Shared/GlobalFilter/context/filtersContext"
import { FiltersType } from "components/Shared/GlobalFilter/context/interfaces"
import Select from "components/Shared/Filters/Select"
import "./index.scss"

interface FormatProps {
	setStoreFilters?: (key: string, filters: Array<Tuple>) => void
}

const Format: React.FC<FormatProps> = ({ setStoreFilters }) => {
	const { filters } = useFiltersContext()
	const [selectedValues, setSelectedValues] = useState<FiltersType>(filters)

	const handleFilters = (filterId: string, selectedFilters: Array<Tuple>) => {
		setSelectedValues({ ...selectedValues, [filterId]: selectedFilters })
		setStoreFilters && setStoreFilters(filterId, selectedFilters)
	}

	const {
		data: formats,
		refetch: fetchFormats,
		isFetching: isFetchingFormats,
	} = useFetchFilters<Tuple>(
		FORMATS_FILTER_ENDPOINT,
		FORMATS_FILTER,
		{
			[REGIONS]: selectedValues.regions,
			[COUNTIES]: selectedValues.counties,
		},
		true
	)

	useEffect(() => {
		fetchFormats()
	}, [])

	return (
		<div className="filter-format">
			<PanelContent id={FORMATS} selectedValues={selectedValues.formats}>
				<Select
					id={FORMATS}
					onChange={(value: Tuple[]) => handleFilters(FORMATS, value)}
					options={formats}
					isLoading={isFetchingFormats}
					hasTitle={false}
					allOption
					isMulti
				/>
			</PanelContent>
		</div>
	)
}

export default Format
